import React, { useState } from "react";
import { createChatBotMessage } from "react-chatbot-kit";

const TrackOrder = (props) => {
  const [mobile, setMobile] = useState("");

  const fetchOrderId = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_PHONEPE_NODE_URL}/api/order/order-by-mobile/${mobile}/${window.location.hostname}`
      );
      const data = await response.json();

      let messages = [];

      if (data.success && Array.isArray(data.orderId)) {
        data.orderId.forEach((id) => {
          const trackingUrl = `https://${window.location.hostname}/order-tracking?orderId=${id}`;
          messages.push(createChatBotMessage(`Your Order ID: ${id}`));
          // messages.push(
          //   createChatBotMessage(
          //     `You can track your order here: (${trackingUrl})`
          //   )
          // );
          messages.push(
            createChatBotMessage("You can track your order here:", {
              widget: "trackOrderLink",
              payload: trackingUrl,
            })
          );
        });
      } else {
        messages.push(createChatBotMessage("Order ID not found."));
      }

      props.setState((prev) => ({
        ...prev,
        messages: [...prev.messages, ...messages],
      }));
    } catch (error) {
      console.error("Error fetching order ID", error);
      const errorMessage = createChatBotMessage(
        "Something went wrong. Please try again."
      );
      props.setState((prev) => ({
        ...prev,
        messages: [...prev.messages, errorMessage],
      }));
    }
  };

  const style = {
    border: `1px solid ${process.env.REACT_APP_THEAM_COLOR}`,
    width: "100%",
    borderRadius: 5,
    padding: "5px 10px",
    fontSize: 14,
    color: "#000",
    background: "transparent",
    cursor: "pointer",
    transition: "all 0.3s ease-in-out",
  };

  const buttonStyle = {
    position: "absolute",
    right: 0,
    color: "#fff",
    top: 0,
    bottom: 0,
    background: process.env.REACT_APP_THEAM_COLOR,
    border: "none",
  };

  return (
    <div style={{ position: "relative" }}>
      <input
        type="text"
        value={mobile}
        style={style}
        onChange={(e) => setMobile(e.target.value)}
        placeholder="Enter mobile number"
      />
      <button style={buttonStyle} onClick={fetchOrderId}>
        Submit
      </button>
    </div>
  );
};

export default TrackOrder;
